<template>
  <!-- A spinner and a ticking timer, so a long wait visibly shows it's still going. -->
  <span class="inline-flex items-center gap-2 text-gray-600" role="status" aria-live="polite" data-test="hermes-working">
    <font-awesome-icon :icon="['fas', 'circle-notch']" class="animate-spin text-primary-500" />
    <span>{{ label }}</span>
    <span v-if="since" class="tabular-nums text-gray-500" data-test="hermes-working-elapsed">{{ elapsed }}</span>
  </span>
</template>

<script>
export default {
  name: 'HermesWorking',
  props: {
    label: { type: String, required: true },
    // When the work started (ISO string); the timer counts from here.
    since: { type: String, default: '' },
  },
  data() {
    return { now: Date.now(), ticker: null };
  },
  computed: {
    elapsed() {
      const seconds = Math.max(0, Math.floor((this.now - Date.parse(this.since)) / 1000));
      return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
    },
  },
  mounted() {
    this.ticker = setInterval(() => { this.now = Date.now(); }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.ticker);
  },
};
</script>
